import { LogArea, LogType, MsgInput } from './const';
import { ILogger } from './ilogger';
import ConsoleLogger from './logger.console';
import { parseArray } from './utils';

let LOGGER_TYPES: string[] = [];
let LOGGER_AREAS: string[] = [];
let logger: ILogger = ConsoleLogger;

const showLogType = (t: LogType) =>
  LOGGER_TYPES.includes(LogType.All) || LOGGER_TYPES.includes(t);

const showLogArea = (a: LogArea) =>
  LOGGER_AREAS.includes(LogArea.All) || LOGGER_AREAS.includes(a);

export const info = (msg: MsgInput, area = LogArea.Dev): void => {
  showLogType(LogType.Info) &&
    showLogArea(area) &&
    logger.log(LogType.Info, msg, area);
};
export const warn = (msg: MsgInput, area = LogArea.Dev) => {
  showLogType(LogType.Warn) &&
    showLogArea(area) &&
    logger.log(LogType.Warn, msg, area);
};
export const error = (msg: MsgInput, area = LogArea.Dev) => {
  showLogType(LogType.Error) &&
    showLogArea(area) &&
    logger.log(LogType.Error, msg, area);
};

export const initLogger = (l: ILogger = ConsoleLogger, loggerTypes = '[]', loggerAreas =  '[]', showInitialValues = false) => {
  l.init();
  logger = l;
  LOGGER_TYPES = parseArray(loggerTypes);
  LOGGER_AREAS = parseArray(loggerAreas);
  info(['Initialzing logger'], LogArea.Logger);
  if (showInitialValues) {
    info(['LOGGER SETTINGS', LOGGER_TYPES, LOGGER_AREAS], LogArea.Logger);
    info(['LOGGER CONSTANTS', LogType, LogArea], LogArea.Logger);
  }
};

const Logger = { info, warn, error, initLogger };
export default Logger;
